<template>
  <div>
    <div class="tw-p-6">
      <div class="tw-flex tw-items-center tw-gap-3 tw-justify-between tw-pr-8">
        <div>
          <div class="d-flex align-items-center justify-content-center tw-mb-3">
            <Typography variant="headline-5"> Activity history </Typography>
          </div>
        </div>
        <div>
          <div class="tw-flex tw-items-center tw-gap-3">
            <IconButton
              v-if="showSelection"
              class="tw-w-10 tw-h-10 tw-items-center tw-justify-center tw-flex"
              @click="selectPrev"
              ><v-icon>mdi-chevron-left</v-icon></IconButton
            >
            <IconButton
              v-if="showSelection"
              class="tw-w-10 tw-h-10 tw-items-center tw-justify-center tw-flex"
              @click="selectNext"
              ><v-icon>mdi-chevron-right</v-icon></IconButton
            >
          </div>
        </div>
      </div>
      <div
        class="tw-my-3 tw-gap-3 tw-border tw-border-solid tw-border-gray-400 tw-rounded-lg tw-p-3 tw-flex tw-items-center"
      >
        <div>
          <div class="tw-w-[72px] tw-h-[72px]">
            <CustomImage
              :src="avatarUrl"
              class="tw-w-full tw-h-full tw-object-cover tw-rounded-full tw-overflow-hidden"
              :emptySrc="require('@/assets/img/empty_avatar.png')"
              width="72"
              height="72"
            />
          </div>
        </div>
        <div>
          <Typography variant="headline-6">{{
            currentCandidate?.name
          }}</Typography>
          <Typography variant="body-1" class="tw-mt-1">
            {{ candidateCurrentTitle }}
          </Typography>
          <Typography variant="body-2">
            {{ candidateLocation }}
          </Typography>
        </div>
      </div>
      <History :history="history" />
    </div>
  </div>
</template>

<script>
import Typography from '@/components/v3/base/Typography';
import CustomImage from '@/components/card/CustomImage';
import DefaultAvatar from '@/assets/img/empty_avatar.png';
import IconButton from '@/components/v3/base/IconButton';

export default {
  components: {
    History: () => import('@/components/history'),
    Typography,
    CustomImage,
    IconButton,
  },

  props: ['candidates', 'isFullSize'],

  data() {
    return {
      index: 0,
    };
  },

  computed: {
    showSelection() {
      return this.getCount > 1;
    },

    currentCandidate() {
      if (!this.candidates) {
        return null;
      }

      return this.candidates[this.getIndex()];
    },

    getCount() {
      return this.candidates ? this.candidates.length : 0;
    },

    history() {
      // Make a copy and return the reversed value.
      // TODO: Maybe reverse at the server side
      return this.currentCandidate.history.slice().reverse();
    },

    avatarUrl() {
      if (this.currentCandidate) {
        return (
          this.currentCandidate.picture_url ||
          this.currentCandidate.profile_pic_url ||
          DefaultAvatar
        );
      }
      return DefaultAvatar;
    },

    candidateCurrentTitle() {
      if (
        !this.currentCandidate.experiences ||
        !this.currentCandidate.experiences.length
      )
        return '';
      return `${this.currentCandidate.experiences[0].title} at ${this.currentCandidate.experiences[0].company}`;
    },

    candidateLocation() {
      if (this.currentCandidate.location) return this.currentCandidate.location;
      let location = '';
      if (this.currentCandidate.city)
        location += `${this.currentCandidate.city}, `;
      if (this.currentCandidate.state) location += this.currentCandidate.state;
      else location += this.currentCandidate.country;
      return location;
    },
  },

  methods: {
    selectPrev() {
      this.index -= 1;
    },

    selectNext() {
      this.index += 1;
    },

    getIndex() {
      if (this.index < 0) {
        this.index = 0;
      }

      if (this.index >= this.getCount) {
        this.index = this.getCount - 1;
      }

      return this.index;
    },

    // formattedHistoryEvent(eventCode) {
    //   switch (eventCode) {
    //     case 1:
    //       return "Under Review";
    //     case 2:
    //       return "Manually Imported";
    //     case 3:
    //       return "Approved";
    //     case 4:
    //       return "Rejected";
    //     case 5:
    //       return "Initial Outreach - Email";
    //     case 6:
    //       return "Initial Outreach - Manual";
    //     case 7:
    //       return "Initial Outreach - LinkedIn";
    //     case 8:
    //       return "Interview";
    //     case 9:
    //       return "Candidate Not Interested";
    //     case 10:
    //       return "Follow-up #1";
    //     case 11:
    //       return "Follow-up #2";
    //     case 12:
    //       return "Follow-up #3";
    //     default:
    //       return "";
    //   }
    // }
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/styles/variables.scss';
@import './scss/tab.scss';

.email-textarea::v-deep textarea {
  line-height: 1rem !important;
}

.alignleft {
  float: left;
}
.alignright {
  float: right;
}

.itemTitle {
  font-size: 0.9rem;
}

.itemTitle:before {
  content: '\A';
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #37b797;
  display: inline-block;
  margin-right: 5px;
}

.scheduledItemTitle {
  font-size: 0.9rem;
}

.scheduledItemTitle:before {
  content: '\A';
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #bebcbc;
  display: inline-block;
  margin-right: 5px;
}

.subtitle {
  font-size: 0.7rem;
  /* margin: 2px; */
}
.candidate-name-box {
  font-size: 14px;
  color: $gray-dark;
  letter-spacing: 0;
  font-weight: 600;
  padding-top: 5px;
}
.notes-box {
  padding-top: 7px;
}
</style>
